import { Outlet, useLocation } from 'react-router-dom';
import { WalletProvider } from '../context/WalletContext';
import { ProductSearchProvider } from '../context/ProductSearchContext';
import BottomNav from '../components/navigation/BottomNav';
import PopAnnouncementModal from '../components/pop/PopAnnouncementModal';
import { MiniChatRoot } from '../mini-chat';

/** 前台主殼：固定底部導覽 + 中間內容區（聊天室隱藏底欄） */
export default function MainLayout() {
  const location = useLocation();
  const isChat = location.pathname.startsWith('/chat');

  return (
    <WalletProvider>
      <ProductSearchProvider>
        <div className={`main-shell ${isChat ? 'main-shell--chat' : ''}`}>
          <main className="main-shell__content">
            <Outlet />
          </main>
          {!isChat ? <BottomNav /> : null}
          <PopAnnouncementModal />
          <MiniChatRoot />
        </div>
      </ProductSearchProvider>
    </WalletProvider>
  );
}
